module.exports = __webpack_public_path__ + "img/at.3ee4ec7b.svg";